import { ArrowRight, Martini } from 'lucide-react';
import { Link } from 'react-router';

export default function BarTeaserDemo() {
  return (
    <div className="w-full max-w-sm border-[3px] border-charcoal-800 bg-charcoal-800 p-6 text-white shadow-neobrutal-lime-10">
      <div className="flex items-center justify-between border-b border-charcoal-700 pb-3">
        <span className="inline-flex items-center gap-2 font-marketing-mono text-[11px] uppercase tracking-[0.12em] text-charcoal-200">
          <Martini className="h-4 w-4 text-lime-500" strokeWidth={2} />
          Écart de la semaine
        </span>
        <span className="font-marketing-mono text-[10px] uppercase tracking-[0.1em] text-terracotta-400">
          Surdosage
        </span>
      </div>

      <ul className="mt-4 space-y-2.5">
        {[
          { name: 'Rhum blanc', delta: '−150 ml', money: '−1 714 F' },
          { name: 'Gin', delta: '−40 ml', money: '−500 F' },
          { name: 'Sirop sucre', delta: '−10 ml', money: '−20 F' },
        ].map((row) => (
          <li
            key={row.name}
            className="flex items-center justify-between gap-3 border-[1.5px] border-charcoal-700 px-3 py-2.5 font-marketing-body text-[13.5px]"
          >
            <span className="text-charcoal-100">{row.name}</span>
            <span className="font-marketing-mono text-[12px] text-charcoal-300">{row.delta}</span>
            <span className="font-marketing-mono text-[12px] font-semibold text-terracotta-400">
              {row.money}
            </span>
          </li>
        ))}
      </ul>

      <Link
        to="/velko-bar"
        className="mt-5 inline-flex w-full items-center justify-center gap-2 border-2 border-lime-500 bg-lime-500 px-4 py-3 font-marketing-display text-[14px] font-bold text-charcoal-800 transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[4px_4px_0_#A3E635]"
      >
        Découvrir Velko Bar
        <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
      </Link>
    </div>
  );
}
